import React, { useState,useEffect } from "react";
import { Card,Button,Typography,Row,Col,Divider,Table,Modal,Form,Input,Select,Space,Checkbox,message, Tooltip} from "antd";
import { MinusCircleOutlined, PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import FilterComponent from "../Components/FiltersDynamicComponent";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import LookupDisplayCard from "../Record/LookupDisplayCard";

const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const ApprovalStep = ({
  selectedObject,
  availableFields,
  users,
  onApprovalStepsChange,
  savedApprovalStep,
  process,
}) => {
  const [approvalSteps, setApprovalSteps] = useState(process? process.steps :[]); // Store approval steps data
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility state
  const [form] = Form.useForm(); // AntD Form instance
  const [logic, setLogic] = useState("");
  const [operator, setOperator] = useState("AND");
  const [isLogicEditable, setIsLogicEditable] = useState(false);
  const [filters, setFilters] = useState([
    { 1: { field: "", value: "", displayValue: "" } },
  ]); // For managing filters
  const [valueOperator, setValueOperator] = useState("");
  const [lookupOptions, setLookupOptions] = useState([]); // For storing lookup options
  const [isEditing, setIsEditing] = useState(false); // Track if editing or adding
  const [editingIndex, setEditingIndex] = useState(null); // Track the index of the step being edited
  const [approverType, setApproverType] = useState("user");
  const [userLookupFields, setUserLookupFields] = useState([]);


  useEffect(() => {
    const lookupFields = availableFields.filter(
      (f) => f.type === "lookup" && f.parent_object_name === "User"
    );
    setUserLookupFields(lookupFields);
  }, [availableFields]); 

  
  // Function to open the modal
  const addApprovalStep = () => {
    setIsEditing(false); // Set editing state to false
    setIsModalOpen(true); // Open the Modal
    form.resetFields(); // Clear the form fields
    setFilters([{ 1: { field: "", value: "", displayValue: "" } }]); // Reset filters
    setLogic(""); // Clear logic string
  };

  // Function to close the modal
  const handleCancel = () => {
    setIsModalOpen(false); // Close the Modal
    form.resetFields(); // Reset the form fields when modal is closed
  };

  const isValidParentheses = (logic) => {
    let stack = [];
    for (let char of logic) {
      if (char === "(") {
        stack.push(char);
      } else if (char === ")") {
        if (stack.length === 0) {
          return false; // Unmatched closing parenthesis
        }
        stack.pop(); // Match found, pop the last open parenthesis
      }
    }
    return stack.length === 0; // Ensure all parentheses are closed
  };

  // Function to handle saving the approval step
  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        //Check if any filter is missing either field or value
        if (logic && !isValidParentheses(logic)) {
          message.error("Invalid logic: Parentheses are not balanced.");
          return; // Stop submission if parentheses are not balanced
        }
        let isValid = true;
        filters.forEach((filter, index) => {
          if (!filter.field) {
            isValid = false;
            // Show error message for the respective filter
            message.error(`Please enter field for filter ${index + 1}`);
          }
        });
        if (Array.isArray(values.actions)) {
          for (let i = 0; i < values.actions.length; i++) {
            const action = values.actions[i];
            if (!action.action || !action.field) {
              message.error(`Please fill action details for row ${i + 1}`);
              return;
            }
          }
        }
  
        if (!isValid) {
          return; // Stop the submission if validation fails
        }
        const filterObj = filters.reduce((acc, filter, index) => {
          if (filter.field) {
            acc[index + 1] = {
              field: filter.field,
              value: filter.operator && filter.value === "" 
            ? { [filter.operator]: "" }  // If operator exists and value is empty, set as JSON object
            : filter.value
            };
          }
          return acc;
        }, {});

      
       
        const newStep = {
          name: values.name,
          description: values.description,
          // approver_id: values.approver,
          display_fields: values.display_fields || [],
          approver_type: values.approverType,
          approver_id: values.approverType === "user" ? values.approver : null,
          approver_field: values.approverType === "field" ? values.approverField : null,
          order: values.order,
          autoApprove: values.autoApprove || false,
          logic_string: logic,
          conditions: filterObj || {},
          actions: values.actions || [],
          send_email: values.send_email || false,
          // email_subject: values.email_subject || "",
          // email_body: values.email_body || "",
          send_notification: values.send_notification || false,
          // notification_message: values.notification_message || "",

        };
        
        let updatedSteps = [...approvalSteps];


        if (isEditing && editingIndex !== null) {
          // Update the existing step
          updatedSteps[editingIndex] = newStep;
        } else {
          // Add a new step
          updatedSteps.push(newStep); // Add a new step
        }

        // const updatedSteps = [...approvalSteps, newStep];
        setApprovalSteps(updatedSteps);

        onApprovalStepsChange(updatedSteps); // Notify parent of changes

        setFilters([{ 1: { field: "", value: "", displayValue: "" } }]);
        setLogic("");
        setIsEditing(false);
        setEditingIndex(null);
        setIsModalOpen(false); // Close the modal after saving
        form.resetFields(); // Reset form fields after saving
        
      })
      .catch((error) => {
        console.log("Validation failed:", error);
      });
  };

  // Function to remove an approval step
  const removeApprovalStep = (index) => {
    const updatedSteps = [...approvalSteps];
    updatedSteps.splice(index, 1);
    setApprovalSteps(updatedSteps);
    if (onApprovalStepsChange) {
      onApprovalStepsChange(updatedSteps); // Notify parent of changes
    }
  };

  const fetchLookupRecordsForExistingFilters = (existingFilters) => {
    existingFilters.forEach((filter) => {
      const selectedField = availableFields.find(
        (field) => field.name === filter?.field?.replace('_id', '')
      );
      if (selectedField && selectedField.type === "lookup") {
        fetchLookupRecords(selectedField.parent_object_name); // Fetch records for lookup fields
      }
    });
  };
  // Function to fetch records for the lookup field
  const fetchLookupRecords = async (objectName) => {
    try {
      const apiServiceForRecords = new ApiService(
        `${BASE_URL}/fetch_records/${objectName}`,
        { "Content-Type": "application/json" },
        "GET"
      );
      const response = await apiServiceForRecords.makeCall();
      // Assuming response is an array of records with _id and Name fields
      const records = response?.records?.map((record) => ({
        value: record._id, // Set _id as value
        label: record.Name, // Set Name as label
      }));
      setLookupOptions(records); // Set options for the lookup field
    } catch (error) {
      const errorMessage =
        error && typeof error === "object"
          ? Object.entries(error)
              .map(
                ([key, value]) =>
                  `${key}: ${Array.isArray(value) ? value.join(", ") : value}`
              )
              .join(" | ")
          : "Failed to save field due to an unknown error";
      message.error(errorMessage);
    }
  };

  const editApprovalStep = (index) => {
    setIsEditing(true); // Set editing state to true
    setEditingIndex(index); // Track the index being edited

    const stepToEdit = approvalSteps[index];


    form.setFieldsValue({
      name: stepToEdit?.name,
      description: stepToEdit?.description,
      order: stepToEdit?.order,
      approver: stepToEdit?.approver_id,
      autoApprove: stepToEdit?.autoApprove,
      actions: stepToEdit?.actions,
      approverType: stepToEdit.approver_type || "user",
      // approver: stepToEdit.approver_id,
      display_fields: stepToEdit?.display_fields || [],
      approverField: stepToEdit.approver_field,
      send_email: stepToEdit.send_email,
      // email_subject: stepToEdit.email_subject,
      // email_body: stepToEdit.email_body,
      send_notification: stepToEdit.send_notification,
      // notification_message: stepToEdit.notification_message,    

    });
    setApproverType(stepToEdit.approver_type || "user");
    
    const existingFilters = stepToEdit?.conditions
        ? Object.entries(stepToEdit?.conditions).map(([key, { field, value }]) => {
          let operator = '';
          let actualValue = '';
          if (Object?.keys(value)[0] !== "0") {
            operator = Object?.keys(value)[0];
            actualValue = value[operator];
          } else {
            actualValue = value; // Extract the actual value (e.g., '50')
          }
          let op = '';
          if (operator !== '') {
            try {
              setValueOperator(operator);
              op = operator;
            } catch (error) {
              // Handle the error gracefully
              setValueOperator(''); // or any default value
            }
          } else {
            op = '';
          }
          return {
            field,
            value: value,
            displayValue: actualValue,
            operator: op
          };
        })
        : [{ field: '', value: '', operator: '' }];
      setFilters(existingFilters); // Set filters state here
    fetchLookupRecordsForExistingFilters(existingFilters);
    // Update the logic string and filters
  setLogic(stepToEdit.logic_string || "");
  //setFilters(stepToEdit.conditions ? Object.values(stepToEdit.conditions) : []);
  
    setIsModalOpen(true); // Open the modal for editing
  };
  
  const approvalStepsColumns = [
    {
      title: "Order",
      dataIndex: "order",
      key: "order",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Display Fields",
      dataIndex: "display_fields",
      render: (list) => list?.join(", ") || "—",
    },    
    {
      title: "Email?",
      render: (r) => (r.send_email ? "Yes" : "No"),
    },
    {
      title: "Notification?",
      render: (r) => (r.send_notification ? "Yes" : "No"),
    },    
    {
      title: "Approver",
      key: "approver",
      render: (record) => {
        // ---- CASE 1: Approver is User ----
        if (record.approver_type === "user") {
          const user = users.find((u) => u.id === record.approver_id);
          return user ? user.name : "Unknown User";
        }
  
        // ---- CASE 2: Approver is Field ----
        if (record.approver_type === "field") {
          const lookupField = availableFields.find(
            (f) => f.name === record.approver_field
          );
          return lookupField ? lookupField.label : "Unknown Field";
        }
  
        return "Unknown";
      },
    },
    {
      title: "Step Entry",
      dataIndex: "conditions",
      key: "conditions",
      render: (conditions) => {
        if (conditions && typeof conditions === "object") {
          return Object.entries(conditions)
            .map(([key, { field, value }]) => `${key}: ${field} : ${JSON.stringify(value)}`)
            .join(", ");
        }
        return "";
      },
    },
    {
      title: "Logic",
      dataIndex: "logic_string",
      key: "logic_string",
      render: (text) => text || "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record, index) => (
        <>
          <Tooltip title="Edit">
            <EditOutlined
              style={{ cursor: "pointer", color: "blue", marginRight: 10 }}
              onClick={() => editApprovalStep(index)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteOutlined
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => removeApprovalStep(index)}
            />
          </Tooltip>
        </>
      ),
    },
  ];
  

  return (
    <div>
      {/* Approval Steps Section */}
      <Card style={{ marginBottom: "20px" }}>
        <Row justify="space-between" align="middle">
          <Col>
            <Title level={4} style={{ margin: 0 }}>
              Approval Steps
            </Title>
          </Col>
          <Col>
            <Button type="primary" onClick={addApprovalStep}>
              Add Approval Step
            </Button>
          </Col>
        </Row>
        <Divider />
        <Table
          columns={approvalStepsColumns}
          dataSource={savedApprovalStep.map((step, index) => ({
            ...step,
            key: index,
          }))}
          pagination={false}
        />
      </Card>

      {/* Modal for Adding Approval Step */}
      <Modal
         title={isEditing ? "Edit Approval Step" : "Add Approval Step"} // Conditional title
        visible={isModalOpen}
        onCancel={handleCancel}
        onOk={handleSave}
        zIndex={1002}   // higher than sidebar
        okText="Save"
        cancelText="Cancel"
        width="50%"
        bodyStyle={{ maxHeight: '60vh', overflowY: 'auto' }} // ✅ scroll applied here

      >
        <Form form={form} layout="vertical" name="approvalStepForm">
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: "Please enter the name!" }]}
          >
            <Input placeholder="Enter the name" />
          </Form.Item>

          <Form.Item
            label="Description"
            name="description"
            // rules={[
            //   { required: true, message: "Please input the description!" },
            // ]}
          >
            <TextArea rows={2} />
          </Form.Item>

          {/* Order Field */}
          <Form.Item
            label="Order"
            name="order"
            rules={[
              { required: true, message: "Please input the order number!" },
            ]}
          >
            <Input type="number" />
          </Form.Item>

          {/* Approver Field */}
          <Form.Item label="Approver Type" name="approverType" initialValue="user">
            <Select onChange={(v) => setApproverType(v)}>
              <Select.Option value="user">User</Select.Option>
              <Select.Option value="field">Field</Select.Option>
            </Select>
          </Form.Item>

          {/* Approver Selector */}
          {approverType === "user" && (
            <Form.Item
              label="Approver"
              name="approver"
              rules={[{ required: true, message: "Please select an approver!" }]}
            >
              <Select placeholder="Select Approver">
                {users?.map((user) => (
                  <Select.Option key={user.id} value={user.id}>
                    {user.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}

          {approverType === "field" && (
            <Form.Item
              label="Approver Field"
              name="approverField"
              rules={[
                { required: true, message: "Please select a user lookup field!" },
              ]}
            >
              <Select placeholder="Select Field">
                {userLookupFields.map((f) => (
                  <Select.Option key={f.name} value={f.name}>
                    {f.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}

          {/* Fields to Show in Approval Request */}
          <Form.Item
            label="Fields to Display"
            name="display_fields"
            rules={[{ required: true, message: "Please select at least one field!" }]}
          >
            <Select
              mode="multiple"
              placeholder="Select fields to display in approval request"
              allowClear
            >
              {availableFields.map((f) => (
                <Select.Option key={f.name} value={f.name}>
                  {f.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Divider />

          <Title level={5}>Notifications</Title>

          <Form.Item name="send_email" valuePropName="checked">
            <Checkbox>Send Email</Checkbox>
          </Form.Item>

          <Form.Item name="send_notification" valuePropName="checked">
            <Checkbox>Send In-App Notification</Checkbox>
          </Form.Item>


         <div style={{marginBottom : '30px'}}>
            <FilterComponent
              fields={availableFields}
              logic={logic}
              setLogic={setLogic}
              filters={filters}
              setFilters={setFilters}
              setValueOperator={setValueOperator}
              valueOperator={valueOperator}
              lookupOptions={lookupOptions}
              fetchLookupRecordsForExistingFilters={
                fetchLookupRecordsForExistingFilters
              }
              fetchLookupRecords={fetchLookupRecords}
              heading={"Step Entry"}
            ></FilterComponent>
          </div>
          <Form.Item name="autoApprove" valuePropName="checked" style={{ display: 'none' }}>
            <Checkbox disabled>Auto Approve</Checkbox>
          </Form.Item>

          {/* Action Subfields (Action, Field, Value) */}
          <Form.List name="actions">
            {(fields, { add, remove }) => (
              <>
                <Form.Item label="Advance Approval Actions">
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    style={{}}
                  >
                    Add Action
                  </Button>
                </Form.Item>
                {fields.map(({ key, fieldKey, name, field }) => (
                  <Row
                    key={key}
                    gutter={16}
                    align="middle"
                    style={{ marginBottom: 8 }}
                  >
                    <Col span={6}>
                      <Form.Item
                        {...field}
                        label="Action"
                        name={[name, "action"]}
                        fieldKey={[fieldKey, "action"]}
                        rules={[
                          {
                            required: false,
                            message: "Please input the action!",
                          },
                        ]}
                      >
                        <Select placeholder="Select Action">
                          <Select.Option value="update_field">
                            Update Field
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        {...field}
                        label="Field"
                        name={[name, "field"]}
                        fieldKey={[fieldKey, "field"]}
                        rules={[
                          {
                            required: false,
                            message: "Please select a field!",
                          },
                        ]}
                      >
                        <Select placeholder="Select Field">
                          {availableFields?.map((fieldOption) => (
                            <Select.Option
                              key={fieldOption._id}
                              value={fieldOption.label}
                            >
                              {fieldOption.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        {...field}
                        label="Value"
                        name={[name, "value"]}
                        fieldKey={[fieldKey, "value"]}
                        rules={[
                          {
                            required: false,
                            message: "Please input the value!",
                          },
                        ]}
                      >
                        <Input placeholder="Value" />
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <Button
                        type="danger"
                        onClick={() => remove(name)}
                        icon={<MinusCircleOutlined />}
                      />
                    </Col>
                  </Row>
                ))}
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    </div>
  );
};

export default ApprovalStep;
